import React from 'react'
import CreatePerson from '../People/CreatePerson'

const CreateStudent = () => <CreatePerson kind="student" />

export default CreateStudent
